import { render, staticRenderFns } from "./RelatorioCompartilhar.vue?vue&type=template&id=5b56f24d&"
import script from "./RelatorioCompartilhar.vue?vue&type=script&lang=js&"
export * from "./RelatorioCompartilhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports